import { render, staticRenderFns } from "./email_address_editor.vue?vue&type=template&id=5b0ffd8e&"
import script from "./email_address_editor.vue?vue&type=script&lang=js&"
export * from "./email_address_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b0ffd8e')) {
      api.createRecord('5b0ffd8e', component.options)
    } else {
      api.reload('5b0ffd8e', component.options)
    }
    module.hot.accept("./email_address_editor.vue?vue&type=template&id=5b0ffd8e&", function () {
      api.rerender('5b0ffd8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/email_address_editor.vue"
export default component.exports